<!-- 查看练习题 -->
<template>
  <div class="el-Exercises">
    <el-row class="content_block mb20">
      <template v-if="true">
        <div class="Title_Info_box">
          <el-row class="title_head_">
            <el-col :span="7">
              <span class="class_img">
                <el-image class="title_E_img" :src="shiti"></el-image>
              </span>
              <span>理论测评详情</span>
            </el-col>
            <el-col :span="17">
              <el-row class="fsxx">
                <span class="class_img">
                  <el-image class="title_E_img" :src="dadui"></el-image>
                </span>
                <span style="color: #F83131;">题数总数：{{ScoreInfo.totalTopic || 0}}</span>
              </el-row>
              <el-row class="fsxx">
                <span class="class_img">
                  <el-image class="title_E_img" :src="dadui"></el-image>
                </span>
                <span style="color: #F83131;">答对题数：{{ScoreInfo.totalRight || 0}}</span>
              </el-row>
              <el-row class="fsxx">
                <span class="class_img">
                  <el-image class="title_E_img" :src="dacuo"></el-image>
                </span>
                <span style="color: #39AA51;">答错题数：{{ScoreInfo.totalWrong || 0}}</span>
              </el-row>
              <el-row class="fsxx">
                <span class="class_img">
                  <el-image class="title_E_img" :src="zongdefen"></el-image>
                </span>
                <span style="color: #FF54A4;">总得分：{{ScoreInfo.totalScore || 0}}</span>
              </el-row>
              <el-row class="fsxx">
                <span class="class_img">
                  <el-image class="title_E_img" :src="zql"></el-image>
                </span>
                <span style="color: #2789E2;">正确率：{{ScoreInfo.accuracy || 0}}%</span>
              </el-row>
              <i class="el-icon-close" @click="$router.go(-1)" style="float: right;font-size: 24px;cursor: pointer;"></i>
            </el-col>
          </el-row>
          <el-divider class="m0"></el-divider>
        </div>
      </template>
      <template v-else>
        <TitleInfo title="理论测评详情" :titleImg="shiti"></TitleInfo>
      </template>

      <el-row style="min-height: 320px;overflow: auto;">
        <el-row>
          <!-- 左侧 -->
          <el-row class="left_Exercises">
            <template v-for="(item,index) in questionList">
              <template v-if="item.length > 0">
                <el-row :class="'exercises_type ' + (item[0].questionType == 1?'danxuan':item[0].questionType == 2?'duoxuan':'panduan')">
                  <el-row class="title_exercises_head" :style="'color: '+(item[0].questionType == 1?'#5464FF':item[0].questionType == 2?'#00BDCE':'#2789E2')+';'">
                    <span class="class_img">
                      <el-image class="title_exercises_img" :src="item[0].questionType == 1?danxuan:item[0].questionType == 2?duoxuan:panduan"></el-image>
                    </span>
                    <span style="margin-left: 10px;">{{$retQuestionType(item[0].questionType)}}</span>
                  </el-row>
                  <el-row class="mb15">
                    <ul>
                      <template v-for='(it,ind) in item'>
                        <li :class="getClassOn(it)" @click="jump(it.teacherOpenCourseMergeResourcesQuestionId)">{{ind + 1}}</li>
                      </template>
                    </ul>
                  </el-row>
                </el-row>
              </template>
            </template>
          </el-row>

          <el-row class="right_Exercises">
            <el-row>
              <el-col :span="16">
                <template v-for="(item,index) in questionList">
                  <template v-if="item.length > 0">
                    <el-button plain size="small" :class="questionTypeClass(item)" @click="butType(index)">
                      <el-image class="but_exercises_img" :src="questionTypeImg(item)"></el-image>
                      {{$retQuestionType(item[0].questionType)}}
                    </el-button>
                  </template>
                </template>
                &nbsp;
              </el-col>
              <el-col :span="8" class="t_r" v-if="questionList">
                <!-- <el-button type="danger" size="small" @click="dialogVisible(2)">
                  <el-image class="but_exercises_img" :src="zhishidian"></el-image>
                  知识点
                </el-button> -->
                  <!-- <el-button size="small" type="success" @click="submitPaper(2)">
                    <el-image class="but_exercises_img" :src="jiaojuan"></el-image>
                    交卷
                  </el-button> -->
              </el-col>
            </el-row>

            <template v-for="(item,index) in questionList">
              <template v-if="item.length > 0">
                <!-- 单选题 -->
                  <el-row :class="'exercises_type ' + index" style="margin: 20px 0 0 0;">
                    <el-row class="title_exercises_head" :style="'color: '+(item[0].questionType == 1?'#5464FF':item[0].questionType == 2?'#00BDCE':'#2789E2')+';'">
                      <span class="class_img">
                        <el-image class="title_exercises_img" :src="item[0].questionType == 1?danxuan:item[0].questionType == 2?duoxuan:panduan"></el-image>
                      </span>
                      <span style="margin-left: 10px;">{{$retQuestionType(item[0].questionType)}}</span>
                    </el-row>
                      <el-row :class="'p20 jump'+it.teacherOpenCourseMergeResourcesQuestionId" v-for='(it,ind) in item' :key="item.teacherOpenCourseMergeResourcesQuestionId">
                        <el-col :span="21" :class="it.studentScore >0?'answerClass':'wrongClass'">
                          <el-row style="float: left;width: 30px;">
                            {{ind + 1}}、
                          </el-row>
                          <el-row style="float: left;width: calc(100% - 30px);line-height: 20px;margin-bottom: 10px;">
                            <!-- <el-row class="questionStemClass" v-html="it.questionStem"></el-row> -->
                            <el-row class="questionStemClass" style="margin-bottom: 10px;">
                              <previewIndex :editorId="it.teacherOpenCourseMergeResourcesQuestionId+'_stem'" styleInfo="border:none;padding:0;" v-if="!$isEmpty(it.questionStem)" :modelValue="it.questionStem"></previewIndex>
                            </el-row>
                          </el-row>
                          <template v-if="it.questionType == 1">
                            <ul style="width: 100%;">
                              <el-radio-group disabled @change="seeQuestion(it)" v-model="radio[it.teacherOpenCourseMergeResourcesQuestionId]">
                                <li v-if="!$isEmpty(it.questionOptionA)">
                                  <el-radio label="A">
                                    <el-row class="optionInfo">A、</el-row>
                                    <el-row class="xuanxiang" v-html="$imgHtml(it.questionOptionA)"></el-row>
                                  </el-radio>
                                </li>
                                <li v-if="!$isEmpty(it.questionOptionB)">
                                  <el-radio label="B">
                                    <el-row class="optionInfo">B、</el-row>
                                    <el-row class="xuanxiang" v-html="$imgHtml(it.questionOptionB)"></el-row>
                                  </el-radio>
                                </li>
                                <li v-if="!$isEmpty(it.questionOptionC)">
                                  <el-radio label="C">
                                    <el-row class="optionInfo">C、</el-row>
                                    <el-row class="xuanxiang" v-html="$imgHtml(it.questionOptionC)"></el-row>
                                  </el-radio>
                                </li>
                                <li v-if="!$isEmpty(it.questionOptionD)">
                                  <el-radio label="D">
                                    <el-row class="optionInfo">D、</el-row>
                                    <el-row class="xuanxiang" v-html="$imgHtml(it.questionOptionD)"></el-row>
                                  </el-radio>
                                </li>
                                <li v-if="!$isEmpty(it.questionOptionE)">
                                  <el-radio label="E">
                                    <el-row class="optionInfo">E、</el-row>
                                    <el-row class="xuanxiang" v-html="$imgHtml(it.questionOptionE)"></el-row>
                                  </el-radio>
                                </li>
                              </el-radio-group>
                            </ul>
                          </template>

                          <template v-if="it.questionType == 2">
                            <ul style="width: 100%;">
                              <el-checkbox-group disabled @change="seeQuestion(it)" v-model="checkbox[it.teacherOpenCourseMergeResourcesQuestionId]">
                                <li v-if="!$isEmpty(it.questionOptionA)">
                                  <el-checkbox label="A">
                                    <el-row class="optionInfo">A、</el-row>
                                    <el-row class="xuanxiang" v-html="$imgHtml(it.questionOptionA)"></el-row>
                                  </el-checkbox>
                                </li>
                                <li v-if="!$isEmpty(it.questionOptionB)">
                                  <el-checkbox label="B">
                                    <el-row class="optionInfo">B、</el-row>
                                    <el-row class="xuanxiang" v-html="$imgHtml(it.questionOptionB)"></el-row>
                                  </el-checkbox>
                                </li>
                                <li v-if="!$isEmpty(it.questionOptionC)">
                                  <el-checkbox label="C">
                                    <el-row class="optionInfo">C、</el-row>
                                    <el-row class="xuanxiang" v-html="$imgHtml(it.questionOptionC)"></el-row>
                                  </el-checkbox>
                                </li>
                                <li v-if="!$isEmpty(it.questionOptionD)">
                                  <el-checkbox label="D">
                                    <el-row class="optionInfo">D、</el-row>
                                    <el-row class="xuanxiang" v-html="$imgHtml(it.questionOptionD)"></el-row>
                                  </el-checkbox>
                                </li>
                                <li v-if="!$isEmpty(it.questionOptionE)">
                                  <el-checkbox label="E">
                                    <el-row class="optionInfo">E、</el-row>
                                    <el-row class="xuanxiang" v-html="$imgHtml(it.questionOptionE)"></el-row>
                                  </el-checkbox>
                                </li>
                              </el-checkbox-group>
                            </ul>
                          </template>

                          <template v-if="it.questionType == 3">
                            <ul>
                              <el-radio-group disabled @change="seeQuestion(it)" v-model="judgeQuestion[it.teacherOpenCourseMergeResourcesQuestionId]">
                                <li>
                                  <el-radio label="对">
                                    <el-row class="xuanxiang">对</el-row>
                                  </el-radio>
                                </li>
                                <li>
                                  <el-radio label="错">
                                    <el-row class="xuanxiang">错</el-row>
                                  </el-radio>
                                </li>
                              </el-radio-group>
                            </ul>
                          </template>
                          <template v-if="it.questionType == 4">
                            <el-row style="margin-bottom: 5px;">
                              <span class="fl mr20">我的得分:{{it.studentScore}} 分</span>
                              <iconInfo :studentScore="it.studentScore" :questionScore="it.questionScore"></iconInfo>
                            </el-row>
                            <el-row style="margin-bottom: 5px;">我的作答:</el-row>
                            <template v-for="i in Number(it.questionOptionA)">
                              <el-input
                                type="textarea"
                                disabled
                                @change="seeQuestion(it,i)"
                                :autosize="{ minRows: 2, maxRows: 4}"
                                placeholder="请输入内容"
                                :style="Number(it.questionOptionA) > 1 && i != Number(it.questionOptionA)?'margin-bottom: 10px;':''"
                                v-model="completion[it.teacherOpenCourseMergeResourcesQuestionId][i]">
                              </el-input>
                            </template>
                          </template>

                          <template v-if="it.questionType == 5">
                            <el-row class="questionStemClass" style="margin-bottom: 10px;">
                              <previewIndex :editorId="it.teacherOpenCourseMergeResourcesQuestionId" v-if="!$isEmpty(it.questionOptionB)" styleInfo="border:none;padding:0px 20px;" :modelValue="it.questionOptionB"></previewIndex>
                            </el-row>
                            <el-row style="margin-bottom: 5px;">
                              <span class="fl mr20">我的得分:{{it.studentScore}} 分</span>
                              <iconInfo :studentScore="it.studentScore" :questionScore="it.questionScore"></iconInfo>
                            </el-row>
                            <el-row style="margin-bottom: 5px;">我的作答:</el-row>
                            <template v-for="i in Number(it.questionOptionA)">
                              <el-input
                                type="textarea"
                                disabled
                                @change="seeQuestion(it,i)"
                                :autosize="{ minRows: 2, maxRows: 4}"
                                placeholder="请输入内容"
                                :style="Number(it.questionOptionA) > 1 && i != Number(it.questionOptionA)?'margin-bottom: 10px;':''"
                                v-model="analyticQuestion[it.teacherOpenCourseMergeResourcesQuestionId][i]">
                              </el-input>
                            </template>
                          </template>

                          <el-row style="line-height: 30px;">
                            <!-- <span class="class_img">
                              <el-image class="title_exercises_img" :src="dadui_icon"></el-image>
                            </span> -->
                            <template v-if="it.questionType == 4 || it.questionType == 5">
                              <el-row>正确答案：</el-row>
                              <el-row v-for="(ite,inde) in JSON.parse(it.questionAnswer)" :key="inde+it.resourcesQuestionSnapshotId">
                                <p class="mt5 mb5"><span style="color: rgb(84, 100, 255);">{{"第"+inde+"空答案："}}</span>{{ite}}</p>
                                <!-- <template v-for="(key,val) in ite">
                                  <p class="mt5 mb5"><span style="color: rgb(84, 100, 255);">{{"第"+val+"空答案："}}</span>{{key}}</p>
                                </template> -->
                              </el-row>
                            </template>
                            <template v-else>
                              <iconInfo :studentScore="it.studentScore" :questionScore="it.questionScore"></iconInfo>
                              <span>正确答案：{{it.questionAnswer}}</span>
                              <!-- <span style='color: #5464FF;'>（{{it.questionScore}} 分）</span> -->
                              <span style='color: #5464FF;margin-left: 20px;'>我的作答：{{it.myOptions}} </span>
                              <span style='color: #5464FF;margin-left: 20px;'>我的得分：{{it.studentScore}} 分</span>

                            </template>
                            <p v-if="!$isEmpty(item.questionAnalysis)">解析：{{item.questionAnalysis}}</p>
                          </el-row>
                        </el-col>
                        <!-- <el-col :span="3" class="t_r">
                          <el-button size="small" plain @click="collection(it)">
                            <el-image class="but_exercises_img" :src="shouc"></el-image>
                            {{it.isTuck ? '已': ''}}收藏
                          </el-button>
                        </el-col> -->
                      </el-row>
                  </el-row>
              </template>
            </template>
           </el-row>
        </el-row>
      </el-row>
    </el-row>

    <!-- 知识点查看对话框 -->
    <el-dialog
      :visible.sync="show_points"
      class="points_class_dialog"
      width="800px">
      <span slot="title" class="dialog-footer" style="font-weight: bold;">
        <el-image style="width: 22px;float: left;margin-right: 10px;" :src="zhisdian"></el-image>
        查看知识点
      </span>
      <el-row style="height: 400px;">
        <el-col :span="6" class="left_box">
          <div style="border:1px solid #D3D3D3;margin-right:20px">
            <p class="m0 p10 tc fontB" style="background-color: #EFF2F7;">知识点名称</p>
            <ul>
              <template v-for="(item,index) in KnowledgePointList">
                <li :class="index == onKnowledgePoint?'on':''" @click="seeKnowledgePoint(item,index)">{{item.knowledgePointTitle}}</li>
              </template>
            </ul>
          </div>
        </el-col>
        <el-col :span="18" class="rigth_box">
          <el-row style="border:1px solid #D3D3D3;height: 380px;padding: 10px;line-height: 30px;overflow: auto;">
            <el-row>
              <el-col :span="12" class="fontB">
                <el-image style="width: 22px;float: left;margin-right: 10px;margin-top: 4px;" :src="cont"></el-image>
                知识点内容
              </el-col>
              <!-- <el-col :span="12" class="t_r">
                <el-button size="small" plain v-if="!$isEmpty(knowledgePointInfo.knowledgePointContent)">
                  <el-image class="but_exercises_img" :src="shouc"></el-image>
                  收藏
                </el-button>
              </el-col> -->
            </el-row>
            <el-row>
              <el-row v-html="knowledgePointInfo.knowledgePointContent">

              </el-row>
            </el-row>
          </el-row>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import TitleInfo from "@/components/TitleInfo";	//页面头部
import jQuery from 'jquery';
import previewIndex from "@/components/editorMd/previewIndex";	//富文本editorMd
import iconInfo from "@/components/iconInfo";
export default {
  name: "TaskExercisesDetails",
  components: {
  	TitleInfo,
    previewIndex,
    iconInfo
  },
  data() {
    return {
      taskId:this.$route.query.taskId,
      shiti:require("../../images/course/shiti@2x.png"),
      danxuan:require("../../images/course/danxuan@2x.png"),
      danxuan_b:require("../../images/course/danxuan-b@2x.png"),
      duoxuan:require("../../images/course/duoxuan@2x.png"),
      duoxuan_b:require("../../images/course/duoxuan-b@2x.png"),
      panduan:require("../../images/course/panduan@2x.png"),
      panduan_b:require("../../images/course/panduan-b@2x.png"),
      zhishidian:require("../../images/course/zhishidian@2x.png"),
      jiaojuan:require("../../images/course/jiaojuan@2x.png"),
      shouc:require("../../images/course/shouc@2x_1.png"),
      shouc_b:require("../../images/course/shouc@2x_2.png"),
      cont:require("../../images/course/cont@2x.png"),
      zhisdian:require("../../images/course/zhisdian@2x.png"),
      dadui:require("../../images/course/dadui@2x.png"),
      dadui_icon:require("../../images/course/dadui_icon@2x.png"),
      dacuo:require("../../images/course/dacuo@2x.png"),
      dacuo_i:require("../../images/course/dacuo_i@2x.png"),
      zql:require("../../images/course/zql@2x.png"),
      zongdefen:require("../../images/course/zongdefen@2x.png"),
      zongdefen:require("../../images/course/zongdefen@2x.png"),
      onButType:0, //0:单选 1：多选 2：判断
      radio:{}, //单选题答案
      checkbox:{},//多选题答案
      judgeQuestion:{},//判断题
      completion:{}, //填空题
      analyticQuestion:{}, //分析题
      show_points: false, //知识点查看对话框
      questionList:{//题目格式化成1单选 2多选 3判断 4填空 5分析
        "questionType1":[],
        "questionType2":[],
        "questionType3":[],
        "questionType4":[],
        "questionType5":[],
      },
      questionListInfo:[], //题目List
      onInfo:0,
      KnowledgePointList:[], //知识点List
      knowledgePointInfo:{},
      onKnowledgePoint:0,
      time:0, //当前系统时间
      setIntervalName:null,
      ScoreInfo:{}
    };
  },
  created() {
    if(!this.$isEmpty(this.taskId)){
      this.getInfo();
      this.getScoreInfo();
      // this.getKnowledgePoint();
      // this.getDateTime();
    }
  },
  beforeDestroy() {  //利用vue的生命周期函数 销毁定时器
    if(this.setIntervalName) {
    　　clearInterval(this.setIntervalName); //关闭
    }
  },
  mounted() {

  },
  computed: {
    questionTypeClass(){
      return function (item) {
        return  item[0].questionType == 1 && this.onButType == 'questionType1'?'danxuan_but':
                item[0].questionType == 2 && this.onButType == 'questionType2'?'duoxuan_but':
                item[0].questionType == 3 && this.onButType == 'questionType3'?'panduan_but':'';
      }
    },
    getClassOn(){
      return function (it) {
        if(it.myOptions == it.questionAnswer || it.studentScore == it.questionScore){
          return "zq";
        }else if(it.studentScore != it.questionScore){
          return "dc";
        }else{
          return "";
        }
      }
    },
    questionTypeImg(){
      return function (item) {
        if(item[0].questionType == 1 && this.onButType == 'questionType1'){
          return this.danxuan;
        }else if(item[0].questionType == 1 && this.onButType != 'questionType1'){
          return this.danxuan_b;
        }else if(item[0].questionType == 2 && this.onButType == 'questionType2'){
          return this.duoxuan;
        }else if(item[0].questionType == 2 && this.onButType != 'questionType2'){
          return this.duoxuan_b;
        }else if(item[0].questionType == 3 && this.onButType == 'questionType3'){
          return this.panduan;
        }else if(item[0].questionType == 3 && this.onButType != 'questionType3'){
          return this.panduan_b;
        }else if(!this.$isEmpty(this.onButType)){
          return this.panduan_b;
        }else{
          return this.panduan;
        }
      }
    },
  },
  methods: {
    getScoreInfo(){
      this.$get("/api/studentHandsOnTaskTheory/getHandsOnTaskkTheoryDetailByTaskIdTotal",{
        taskId:this.taskId,
        fromTypeEnum:"EXAM"
        }).then((ret) =>{
        if(ret.code == 0){
          this.ScoreInfo = ret.data || {};
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      }).catch(() => {

      });
    },
    getInfo(){ //获取列表
      const loading = this.$loading({
        lock: true,
        text: '加载题目中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$get("/api/studentHandsOnTaskTheory/getHandsOnTaskkTheoryDetailByTaskId",{
        taskId:this.taskId,
        fromTypeEnum:"EXAM"
        }).then((ret) =>{
          loading.close();
        if(ret.code == 0){
          if(!this.$isEmpty(ret.data) && ret.data.length > 0){
            this.questionListInfo = ret.data;
            ret.data.forEach((item,i)=>{ //处理题目数据，按照自己的需求根据不同题目类型格式化
              item.questionIndex = i;
              this.questionList['questionType'+item.questionType].push(item);
              if(item.questionType == 1){
                this.radio[item.teacherOpenCourseMergeResourcesQuestionId] = item.questionAnswer;
              }else if(item.questionType == 2){
                this.checkbox[item.teacherOpenCourseMergeResourcesQuestionId] = !this.$isEmpty(item.questionAnswer)?item.questionAnswer.split(","):[];
              }else if(item.questionType == 3){
                this.judgeQuestion[item.teacherOpenCourseMergeResourcesQuestionId] = item.questionAnswer;
              }else if(item.questionType == 4){
                if(!this.$isEmpty(item.myOptions)){
                  let myOptions = JSON.parse(item.myOptions);
                  this.completion[item.teacherOpenCourseMergeResourcesQuestionId] = {};
                  for(let obj in myOptions){
                   this.completion[item.teacherOpenCourseMergeResourcesQuestionId][obj] = myOptions[obj];
                  }
                }else{
                  this.completion[item.teacherOpenCourseMergeResourcesQuestionId] = {};
                }
              }else if(item.questionType == 5){
                if(!this.$isEmpty(item.myOptions)){
                  let myOptions = JSON.parse(item.myOptions);
                  this.analyticQuestion[item.teacherOpenCourseMergeResourcesQuestionId] = {};
                  for(let obj in myOptions){
                   this.analyticQuestion[item.teacherOpenCourseMergeResourcesQuestionId][obj] = myOptions[obj];
                  }
                }else{
                  this.analyticQuestion[item.teacherOpenCourseMergeResourcesQuestionId] = {};
                }
              }
            });
            this.radio = Object.assign({},this.radio);
            this.checkbox = Object.assign({},this.checkbox);
            this.judgeQuestion = Object.assign({},this.judgeQuestion);
            this.completion = Object.assign({},this.completion);
            this.analyticQuestion = Object.assign({},this.analyticQuestion);
          }
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      }).catch(() => {
        loading.close();
        this.$router.go(-1);
      });
    },
    getDateTime(){
      this.$get("/api/base/dateTime.do").then((ret) =>{
        if(ret.code == 0){
          this.time = ret.data.timestamp; //时间戳：timestamp 年月日时分秒：dateTime
          this.setIntervalName = setInterval(()=>{
            this.time = Number(this.time) + 1000;
          },1000)
        }
      });
    },
    butType(index){ //选择题型
      this.onButType = index;
      let parents_total = jQuery("."+index).position().top;
      jQuery(".right_Exercises").animate({scrollTop:parents_total},1000);//1000是ms,也可以用slow代替
    },
    jump (index) { //点击相应题目跳转至相应位置
       this.onInfo =index;
       let parents_total = jQuery(".jump"+index).parents(".exercises_type").position().top;
       let total = jQuery(".jump"+index).position().top;
       let top = jQuery(".right_Exercises").scrollTop(); //当前滚动条的高度
       jQuery(".right_Exercises").animate({scrollTop:parents_total + total + top + 20},1000);//1000是ms,也可以用slow代替
    },
    dialogVisible(){ //知识点查看
      if(this.KnowledgePointList.length <= 0){
        this.$message.warning("暂无知识点信息！");
        return;
      }
      this.show_points = true;
    },
    seeQuestion(item,key){ //做题，题目变动时调用
      //let param = {questionLogMap:{}};
      // if(item.questionType == 1){
      //   param.questionLogMap[item.teacherOpenCourseMergeResourcesQuestionId] = this.radio[item.teacherOpenCourseMergeResourcesQuestionId];
      // }else if(item.questionType == 2){
      //   param.questionLogMap[item.teacherOpenCourseMergeResourcesQuestionId] = this.checkbox[item.teacherOpenCourseMergeResourcesQuestionId].join(",");
      // }else if(item.questionType == 3){
      //   param.questionLogMap[item.teacherOpenCourseMergeResourcesQuestionId] = this.judgeQuestion[item.teacherOpenCourseMergeResourcesQuestionId];
      // }
      // param.questionLogAddType = "PRE_SUBMIT";
      // {
      //   teacherOpenCourseMergeResourcesQuestionId:item.teacherOpenCourseMergeResourcesQuestionId,
      //   taskId:item.taskId,
      //   teacherOpenCourseId:item.teacherOpenCourseId,
      //   teacherOpenCourseMergeCourseInfoId:item.teacherOpenCourseMergeCourseInfoId
      // }
      if(item.questionType == 1){
        this.questionListInfo[item.questionIndex].myOptions = this.radio[item.teacherOpenCourseMergeResourcesQuestionId];
      }else if(item.questionType == 2){
        this.questionListInfo[item.questionIndex].myOptions = this.checkbox[item.teacherOpenCourseMergeResourcesQuestionId].join(",");
      }else if(item.questionType == 3){
        this.questionListInfo[item.questionIndex].myOptions = this.judgeQuestion[item.teacherOpenCourseMergeResourcesQuestionId];
      }else if(item.questionType == 4){ //填空题
        if(this.$isEmpty(this.completion[item.teacherOpenCourseMergeResourcesQuestionId][key])){
          delete this.completion[item.teacherOpenCourseMergeResourcesQuestionId][key]
        }
        if(Object.keys(this.completion[item.teacherOpenCourseMergeResourcesQuestionId]).length > 0){
          this.questionListInfo[item.questionIndex].myOptions = JSON.stringify(this.completion[item.teacherOpenCourseMergeResourcesQuestionId]);
        }else{
          this.questionListInfo[item.questionIndex].myOptions = "";
        }
      }else if(item.questionType == 5){ //分析题
        if(this.$isEmpty(this.analyticQuestion[item.teacherOpenCourseMergeResourcesQuestionId][key])){
          delete this.analyticQuestion[item.teacherOpenCourseMergeResourcesQuestionId][key]
        }
        if(Object.keys(this.analyticQuestion[item.teacherOpenCourseMergeResourcesQuestionId]).length > 0){
          this.questionListInfo[item.questionIndex].myOptions = JSON.stringify(this.analyticQuestion[item.teacherOpenCourseMergeResourcesQuestionId]);
        }else{
          this.questionListInfo[item.questionIndex].myOptions = "";
        }
      }
      this.$postJSON("/api/studentHandsOnTaskTheory/editTemporary.do",this.questionListInfo).then((ret) =>{
        if(ret.code != 0){
          if(item.questionType == 1){
            this.radio[item.teacherOpenCourseMergeResourcesQuestionId] = "";
          }else if(item.questionType == 2){
            this.checkbox[item.teacherOpenCourseMergeResourcesQuestionId] = [];
          }else if(item.questionType == 3){
            this.judgeQuestion[item.teacherOpenCourseMergeResourcesQuestionId]  = "";
          }else if(item.questionType == 4){
            this.completion[item.teacherOpenCourseMergeResourcesQuestionId]  = "";
          }else if(item.questionType == 5){
            this.analyticQuestion[item.teacherOpenCourseMergeResourcesQuestionId]  = "";
          }
          this.questionListInfo[item.questionIndex].myOptions = "";
          this.$message({message: ret.msg,type: 'error'});
        }
      });
      // this.submitInfo(param,item);
    },
    submitPaper(){ //提交试卷
      this.$confirm('是否确定提交试卷？提交后无法修改！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = {questionLogMap:{}};
        for(let key in this.radio){
          if(!this.$isEmpty(this.radio[key])){
            param.questionLogMap[key] = this.radio[key];
          }
        }
        for(let key in this.checkbox){
          if(!this.$isEmpty(this.checkbox[key])){
            param.questionLogMap[key] = this.checkbox[key].join(",");
          }
        }
        for(let key in this.judgeQuestion){
          if(!this.$isEmpty(this.judgeQuestion[key])){
            param.questionLogMap[key] = this.judgeQuestion[key];
          }
        }
        if(Object.keys(param.questionLogMap).length != this.questionListInfo.length){
          this.$confirm('题目未答完！是否确定交卷？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.submitInfo();
          }).catch(() => {
            this.$message({type: 'info',message: '已取消'});
          });
        }else{
          this.submitInfo();
        }
      }).catch(() => {
        this.$message({type: 'info',message: '已取消'});
      });
    },
    submitInfo(){ //提交数据（答案或者交卷数据）
      //param.addTime = this.$timeFormat(this.time,'yyyy-MM-dd HH:mm:ss');
      this.$postJSON("/api/studentHandsOnTaskTheory/edit.do",this.questionListInfo).then((ret) =>{
        if(ret.code == 0){
          this.$message.success('交卷成功!');
          setTimeout(()=>{
            this.$router.go(-1);
          },500);
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    collection(item){ //收藏或者取消收藏
      let param = {
        questionSettingId:item.taskId,
        questionSnapIds:item.teacherOpenCourseMergeResourcesQuestionId,
        isTuck:item.isTuck?false:true
      }
      this.$post("/api/teacherOpenCourseQuestionLog/tuck.do",param).then((ret) =>{
        if(ret.code == 0){
          this.$message.success(item.isTuck?'取消成功!':'收藏成功!');
          item.isTuck = item.isTuck?false:true;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    getKnowledgePoint(){ //获取知识点
      let param = {
        teacherOpenCourseId:this.teacherOpenCourseId,
        chapterId:this.taskId
      }
      this.$post("/api/teacherOpenCourseKnowledgePoint/getPageList.do",param).then((ret) =>{
        if(ret.code == 0){
          this.KnowledgePointList = ret.data;
          if(ret.data != null && ret.data.length > 0){
            this.knowledgePointInfo = ret.data[0];
            this.onKnowledgePoint = 0;
          }
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    seeKnowledgePoint(item,i){ //查看知识点
      this.knowledgePointInfo = item;
      this.onKnowledgePoint = i;
    }
  }
};
</script>
 <style  lang="less">
  .el-Exercises{
    padding: 20px 20px 0;
    .content_block{
      background-color: #ffffff;
    }
    .title_head_{
      line-height: 40px;
      padding: 20px;
    }
    .title_E_img{
      width: 40px;float: left;margin-right: 10px;
    }
    .exercises_type{
      border: 1px solid #D3D3D3;
      margin: 20px 20px 0;
      .title_exercises_head{
        background-color: #EFF2F7;
        padding: 5px 10px;
        line-height: 30px;
      }
      .title_exercises_img{
        width: 30px;
        float: left;
      }
      ul{
        list-style-type:none;
        margin: 0;
        padding: 0;
        width: 421px;
        // max-height: 230px;
        // overflow-y: auto;
      }
    }
    .left_Exercises,.right_Exercises{
      height: calc(100vh - 180px);overflow-y: auto;float: left;
    }
    .left_Exercises{
      width: 485px;border-right: 1px solid #DCDFE6;
      li{
        float: left;
        width: 34px;
        height: 34px;
        line-height: 34px;
        border: 1px solid #D3D3D3;
        text-align: center;
        margin: 15px 0 0 15px;
        cursor: pointer;
        border-radius: 2px;
      }
      .zq{
        background-color: #409EFF;
        color: #ffffff;
        border-color: #409EFF;
      }
      .dc{
        background-color: red;
        color: #ffffff;
        border-color: red;
      }
    }
    .danxuan{
      .on{
        background-color: #5464FF;
        color: #ffffff;
        border-color: #5464FF;
      }
    }
    .duoxuan{
      .on{
        background-color: #00BDCE;
        color: #ffffff;
        border-color: #00BDCE;
      }
    }
    .panduan{
      .on{
        background-color: #2789E2;
        color: #ffffff;
        border-color: #2789E2;
      }
    }
    .right_Exercises{
      width: calc(100vw - 635px);
      float: left;
      overflow: auto;
      padding: 20px;

      ul{
        padding: 10px 0;
        // list-style-type:upper-alpha;
        margin-left: 30px;
      }
      li{
        line-height: 20px;
      }
      // li::marker{
      //   width: 100px;
      // }
      .xuanxiang{
        white-space: pre-wrap;line-height: 20px;
      }
    }
    .but_exercises_img{
      width: 20px;
      height: 20px;
      float: left;
      margin-right:5px;
    }
    .el-button--small{
      padding: 5px 15px;
      line-height: 20px;
    }
    .danxuan_but{
      color: #5464FF;
      border: 1px solid;
    }
    .duoxuan_but{
      color: #00BDCE;
      border: 1px solid;
    }
    .panduan_but{
      color: #2789E2;
      border: 1px solid;
    }
    // .el-radio__input,.el-radio__label,.el-checkbox__input,.el-checkbox__label{
    //   float: left;
    // }
    // .el-radio__label{
    //   white-space: pre-wrap;
    // }
    .points_class_dialog{
      ul{
        list-style-type:none;
        margin: 0;
        padding: 10px;
        height: 320px;
        overflow: auto;
      }
      li{
        line-height: 30px;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
         /*! autoprefixer: off */
         -webkit-box-orient: vertical;
         /* autoprefixer: on */
         cursor: pointer;
      }
      .on{
        color: #2789E2;
      }
      .el-dialog__header{
        border-bottom: 1px solid #D3D3D3;
      }
      .rigth_box{
        p{
          margin: 0 !important;
        }
      }
    }
    .fsxx{
      float: left;
      margin-right: 20px;
    }
    .questionStemClass{
      p{
        padding: 0;margin: 0;
      }
    }
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/pages/course/TaskExercisesDetails.vue